import * as types from './mutation-types'

export default {
  [types.RESET_CURRENT_USER] (state) {
    state.currentUser = null
  },
  [types.BOOTSTRAP_CURRENT_USER] (state, user) {
    state.currentUser = user
  },
  [types.UPDATE_CURRENT_USER] (state, user) {
    state.currentUser = user
  },
  [types.ADD_USER](state, data) {
    state.users.push(data)
  },
  [types.ADD_USERS](state, data) {
    state.users = data.users
  },
  [types.SET_CURRENT_SHOP](state, shop) {
    state.currentShop = shop
  },
  [types.COMPANY_INFO](state, data) {
    state.companyInfo = data
  },
}
